var link_viewer_default = {
  "fontElementMap": "_4vby-",
  "link": "ReYqi",
  "linkInEditor": "M0o-b",
  "linkInViewer": "n2z1j"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
